export default {
  hint: 'Bekræft betalingen hos din bank for at gennemføre din ordre.',
  cancel: 'Annuller betaling',
};
